export default __webpack_public_path__ + "static/media/MAK_Basement_Logo.5319a30d.png";